import { render, staticRenderFns } from "./system-dialog.vue?vue&type=template&id=c9286244&scoped=true"
import script from "./system-dialog.vue?vue&type=script&lang=js"
export * from "./system-dialog.vue?vue&type=script&lang=js"
import style0 from "./system-dialog.vue?vue&type=style&index=0&id=c9286244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9286244",
  null
  
)

export default component.exports